<template>
    <v-data-table
        dense
        :headers="headers"
        :items="data"
        :data="loading"
        :loading="loading"
        :server-items-length="length"
        :options="options"
        @update:options="updateOptions"
        :footer-props="footer"
        disable-sort
        >
        <template v-slot:[`item.code`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.invoice.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.code}}
        </template>
        <template v-slot:[`item.supplier`]="{item}">
            {{item.supplier_code}} - {{item.supplier}}
        </template>
        <template v-slot:[`item.state`]="{item}">
            <PStatus :state="item.state"/>
        </template>

        <template v-slot:[`item.purchase_order_code`]="{item}">
            <span class="text-decoration-underline font-weight-bold" @click="showPurchaseOrder(item)" style="cursor: pointer">
            {{ item.purchase_order_code }}
            </span>
        </template>

    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex'
import PStatus from './../common/PStatus';

export default {
    name: "PurchaseInvoiceList",
    components: {
        PStatus
    },
    data() {
        return {
            footer: {
                'items-per-page-options': [10, 25, 50]
            },
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Supplier", value: "supplier"},
                { text: "Created By", value: "created_by"},
                { text: "Purchase Order", value: "purchase_order_code" },
                { text: "State", value: "state" },
            ],
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            options: "purchase/invoice/options",
            loading: "purchase/invoice/loading",
            length: "purchase/invoice/length",
            data: "purchase/invoice/list",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "purchase/invoice/updateOptions"
        }),
        handleClickRow(item) {
            this.$router.push({name: "PurchaseInvoiceDisplay", params: {id: item.id}})
        },
        showPurchaseOrder(item) {
            this.$router.push({ name: "PurchaseOrderDisplay", params: { id: item.purchase_order_id } });
        }
    }
}
</script>

<style>
